<template>
  <div
    class="category_list"
    :class="{styleChange: style === 2}"
  >
    <span
      v-for="(i, index) in list"
      :key="index"
      class="items"
      :class="{ active: map.id === i.id }"
      @click="clickItem(i)"
    >{{ i[name] }}</span>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'CategoryList',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    },
    style: {
      type: Number,
      default: 1
    },
    defaultId: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const map = reactive({
      id: props.defaultId || ''
    })
    watch(() => {
      props.defaultId && (map.id = props.defaultId)
      return props.defaultId
    }, (value) => {
      map.id = value
    })
    const clickItem = (i) => {
      map.id = i.id
      emit('change', i.id)
    }
    return {
      map,
      clickItem,
      ...toRefs(props)
    }
  }
})
</script>

<style scoped lang="scss">
.category_list {
  margin-top: 20px;
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  padding-bottom: 0;
  .items {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  .active {
    color: #2256f6;
    background: rgba(34, 86, 246, 0.05);
  }
}
.styleChange {
  .items {
    padding-bottom: 10px;
  }
  .active {
    background: #fff;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 3px;
      background: #2256F6;
      bottom: 0px;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>
